import OverviewTable from './OverviewTable'

export default OverviewTable
